import { useTranslation } from 'next-i18next'
import Image from 'next/image'
import React from 'react'

function IntroFeedback() {
  const { t } = useTranslation('avaliacao360')
  return (
    <div className="lg:w-1/2">
      <Image
        src="/images/cards/cards-goodfellas-avaliacao-360.png"
        width={600}
        height={100}
        alt="Avaliação 360"
        className="mx-auto mb-0"
        style={{ width: 'auto', height: 'auto' }}
        priority
      />
      <div className="text-center pt-10 pb-2 mb-8 border-t-1 border-b-1 border-white/10 bg-gradient-to-r from-transparent via-black/50 to-transparent text-white">
        <h1 className="text-5xl mb-6">{t('identificatorBox.title')}</h1>
        <p className="text-xl italic opacity-60 mb-4 mx-auto 2xl:w-4/5">
          {t('identificatorBox.subtitle')}
        </p>
      </div>
    </div>
  )
}

export default IntroFeedback
